<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#2F4858"
    />
    <path
      d="M14.189 35.07C13.5712 35.0684 12.9789 34.8229 12.541 34.387C12.318 34.1688 12.1444 33.9053 12.0319 33.6143C11.9194 33.3233 11.8707 33.0115 11.889 32.7V7.82102C11.8994 7.23345 12.1351 6.67231 12.5472 6.25344C12.9594 5.83456 13.5167 5.58992 14.104 5.57002H26.644C26.9387 5.56749 27.2306 5.62699 27.5007 5.74467C27.7708 5.86234 28.0132 6.03554 28.212 6.25302C28.6188 6.67435 28.8489 7.2354 28.855 7.82102V32.66C28.8784 33.2613 28.6636 33.8476 28.2573 34.2915C27.8511 34.7355 27.2861 35.0012 26.685 35.031H26.485L14.189 35.07ZM14.627 7.05702H14.305C14.0814 7.02666 13.8549 7.08547 13.6743 7.22075C13.4938 7.35603 13.3737 7.55693 13.34 7.78002V32.62C13.3213 32.7332 13.3253 32.849 13.3516 32.9606C13.3778 33.0723 13.426 33.1777 13.4932 33.2706C13.5604 33.3636 13.6454 33.4423 13.7432 33.5023C13.841 33.5623 13.9497 33.6023 14.063 33.62H26.443C27.166 33.62 27.488 33.339 27.488 32.575V7.98202C27.5084 7.75836 27.4395 7.53572 27.2964 7.36264C27.1532 7.18955 26.9475 7.08006 26.724 7.05802H25.8C25.7378 7.38399 25.5532 7.67381 25.2842 7.8681C25.0152 8.06239 24.682 8.14644 24.353 8.10302H16.516C16.1808 8.15603 15.8382 8.07649 15.5606 7.88125C15.2831 7.68601 15.0924 7.3904 15.029 7.05702H14.627Z"
      fill="white"
    />
  </svg>
</template>
